import styled from "styled-components";

export const StyledBrokerHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 64px;
    background-color: var(--color-white);

    .broker-header-content {
        display: flex;
        align-items: center;
        padding: 0;

        .broker-image {
            width: inherit;
            max-width: 150px;
            height: inherit;
            max-height: 32px;
        }
        
        .broker-info-item {
            color: var(--color-primary);
            text-decoration-line: underline;
        }

        .infos-flex-list {
            position: relative;
            overflow: hidden;

            ul {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: space-between;
                padding: 0;
                margin-left: -1px;
                list-style-type: none;

                li {
                    flex-basis: auto;
                    flex-grow: 1;
                    padding: 0 1em;
                    margin: 0.25em 0;
                    font-size: var(--size-14);
                    text-align: center;
                    cursor: pointer;
                    background-color: var(--color-white);
                    border-left: 1px solid var(--color-grey-900);
                }
            }
        }
    }
`;
